import { useContext, type JSX } from "react";
import { NavLink } from "react-router-dom";
import { SidebarContext } from "../../../contexts/SidebarContext";


interface SidebarItemProps {
    icon: JSX.Element;
    text: string;
    path: string;
    end?: boolean;
}

export default function SidebarItem({ icon, text, path, end }: SidebarItemProps) {
    const ctx = useContext(SidebarContext);
    if (!ctx) throw new Error("SidebarItem must be used inside SidebarContext");

    const { expanded, theme } = ctx;

    return (
        <li>
            <NavLink
                to={path}
                end={end}
                className={({ isActive }) =>
                    `relative flex items-center h-11 px-3 py-2 font-medium rounded-xl transition-all duration-200 group
          ${isActive
                        ? `${theme.activeBg} ${theme.activeColor} shadow-sm`
                        : `text-gray-500 hover:text-gray-900 hover:bg-gray-100/80`
                    }`
                }
            >
                {({ isActive }) => (
                    <>
                        {/* Active Indicator (now a div to avoid nesting <a> tags) */}
                        <div className={`absolute left-[-4px] top-1/2 -translate-y-1/2 w-[4px] h-6 rounded-full bg-gradient-to-b from-violet-600 to-fuchsia-600 transition-all duration-300
                            ${isActive ? "scale-y-100 opacity-100" : "scale-y-0 opacity-0"}`} 
                        />

                        <span className="text-xl shrink-0 transition-transform duration-200 group-hover:scale-110 group-active:scale-95">{icon}</span>

                        <span
                            className={`overflow-hidden transition-all duration-300 font-semibold text-sm whitespace-nowrap ${expanded ? "w-40 ml-4 opacity-100" : "w-0 opacity-0"
                                }`}
                        >
                            {text}
                        </span>

                        {!expanded && (
                            <div
                                className="
                      absolute left-full px-3 py-2 ml-4 bg-gray-900 text-white
                      text-xs font-bold rounded-lg invisible opacity-0 -translate-x-3 
                      group-hover:visible group-hover:opacity-100 group-hover:translate-x-0
                      transition-all duration-200 shadow-xl whitespace-nowrap z-50
                    "
                            >
                                {text}
                                {/* Triangle arrow for tooltip */}
                                <div className="absolute left-[-4px] top-1/2 -translate-y-1/2 w-2 h-2 bg-gray-900 rotate-45" />
                            </div>
                        )}
                    </>
                )}
            </NavLink>
        </li>
    );
}
